<div class="wre-timeline-card" ngClass="updated-users">
  <div class="card-body">
    <div class="wre-timeline-time" *ngIf="audit.date">
      {{ audit.date  | date : 'EEEE dd MMMM yyyy, hh:mm:ss a'}}
      <div *ngIf="audit.isCollapsable" style="float: right; cursor: pointer;" data-bs-toggle="collapse"
        [attr.data-bs-target]="'#collapse'+title" aria-expanded="true"
        [attr.aria-controls]="'collapse'+title" class="collapseIcon">
        <span class="collapseDetailsTitle me-1"> Collapse</span>
        <span class="collapseTitle me-1">Details</span>
        <i class='fas fa-chevron-down'></i>
      </div>
    </div>
    <div *ngIf="audit.title">
        {{ audit.title }}
    </div>
    <div class="wre-timeline-user" *ngIf="audit.actionBy">
      Actioned By: {{ audit.actionBy }}
    </div>
  </div>
</div> 
<div *ngIf="audit.isCollapsable">
  <div [attr.id]="'collapse'+title" class="collapse tabbed-content show border-top border-light hideTabList">
     <ul ngbNav #nav="ngbNav" class="nav-tabs">
      <li ngbNavItem="audit.history">
        <ng-template ngbNavContent>
          <div class="row">
            <div class="col"> 
              <div class="wre-tab-container">
                <wre-field-history-data-table *ngIf="audit.history" [list]="audit.history" [fieldType]="fieldType" ></wre-field-history-data-table>
              </div>
            </div>
          </div>
        </ng-template>
      </li>
    </ul> 
    <div [ngbNavOutlet]="nav"></div>
  </div>
</div>

